<script>
import CommonConstants from '../../../common/Constants';
import config from '../../../common/genericPanelConf';
import Utils from '../../../common/Utils';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Service from '@/services/planning';
import CommonService from '@/services/common';
import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row';                   // optional

import ResponsiveButton from '../../../components/generic/ResponsiveButton.vue'


export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
    ResponsiveButton,
    ColumnGroup,
    Row
  },
  data(){
    return {
        monthDate: Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),
        columns: [],
        data: [],
        headerColumns: {},
        columnConfigurations: [],
        loading: false
    }
  },
  validations(){
    return {
        
    }
  },
  watch:{

  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    //this.configuration = config.getConfiguration('PricedQuantitiesBalance');
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'PricedQuantitiesBalance.page_title');
  },
  methods: {
    getGrid(){
        let body  = {
            monthDate: Utils.formatDateForAPI(this.monthDate),
        }
        this.loading = true;

        this.$store.dispatch("generic/setLoading", true);
        Service.getPricedQuantitiesBalanceGrid(body, response => {
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
                this.data = response.data.data;
                this.columnConfigurations = response.data.columnConfigurations;
                this.generateColumns(response.data.columnConfigurations);
            }
            this.loading = false;
        });
    },
    generateColumns(columnConfigurations){
        this.columns = [];
        this.headerColumns = {
            products: {},
            feedstocks: {}
        }

        for(let i= 0; i<columnConfigurations.length; i++){
            let columnConfiguration = columnConfigurations[i];

            if(columnConfiguration.isProduct){
                if(!this.headerColumns.products[columnConfiguration.name])
                {
                    this.headerColumns.products[columnConfiguration.name] = 0;
                }             
            }else{
                if(!this.headerColumns.feedstocks[columnConfiguration.name])
                {
                    this.headerColumns.feedstocks[columnConfiguration.name] = 0
                }
            }

            this.columns.push({
                data: 'cubicMeters',
                type: 'decimal',
                label: 'M3',
                decimalPrecision: 3,
                familyName: columnConfiguration.name
            });

            if(columnConfiguration.isProduct){
                this.headerColumns.products[columnConfiguration.name] += 1;
            }else{
                this.headerColumns.feedstocks[columnConfiguration.name] += 1;
            }

            this.columns.push({
                data: 'density',
                type: 'decimal',
                label: 'D15',
                decimalPrecision: 4,
                familyName: columnConfiguration.name
            });

            if(columnConfiguration.isProduct){
                this.headerColumns.products[columnConfiguration.name] += 1;
            }else{
                this.headerColumns.feedstocks[columnConfiguration.name] += 1;
            }

            this.columns.push({
                data: 'metricTonnes',
                type: 'decimal',
                label: 'MT',
                decimalPrecision: 3,
                familyName: columnConfiguration.name
            });

            if(columnConfiguration.isProduct){
                this.headerColumns.products[columnConfiguration.name] += 1;
            }else{
                this.headerColumns.feedstocks[columnConfiguration.name] += 1;
            }

            if(columnConfiguration.isConversionFactorVisible){
                this.columns.push({
                    data: 'conversionFactor',
                    type: 'decimal',
                    label: 'CF',
                    decimalPrecision: 3,
                    familyName: columnConfiguration.name
                });

                if(columnConfiguration.isProduct){
                    this.headerColumns.products[columnConfiguration.name] += 1;
                }else{
                    this.headerColumns.feedstocks[columnConfiguration.name] += 1;
                }
            }    
            
            if(columnConfiguration.isBarrelUoMVisible){
                this.columns.push({
                    data: 'barrels',
                    type: 'decimal',
                    label: 'BBL',
                    decimalPrecision: 3,
                    familyName: columnConfiguration.name
                });

                if(columnConfiguration.isProduct){
                    this.headerColumns.products[columnConfiguration.name] += 1;
                }else{
                    this.headerColumns.feedstocks[columnConfiguration.name] += 1;
                }
            }    
        }
    },
    calculateColspan(column){
        let count = 0;

        for(const property in column){
            count += column[property];
        }

        return count;
    },
    calculateColspanFamily(column){
        let count = 3;

        if(column.isConversionFactorVisible){
            count++;
        }

        if(column.isBarrelUoMVisible){
            count++;
        }

        return count;
    },
    rowClass(row){

        if(row.isOfftakeItem || row.isBalanceItem || row.isSubTotal || row.isTargetItem){
            return 'bold-item';
        }

        if(row.description == 'Pre True Up' || row.description == 'True Up' || row.description == 'Roll Over'){
            return 'background-item';
        }
    },
    calculate(){
        this.$confirm.require({
            message: this.$t('messages.calculate_priced_quantities_balance'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.$t('yes'),
            rejectLabel: this.$t('no'),
            accept: () => {                  
                let body = {
                    monthStartDate: Utils.formatDateForAPI(this.monthDate)
                }

                this.$store.dispatch("generic/setLoading", true);
                Service.calculatePricedQuantitiesBalance(body, response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                        this.getGrid();
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            },
            reject: () => {
                this.$confirm.close();
            }
        });
    },
    exportExcel(){
        let body = {
            monthDate: Utils.formatDateForAPI(Utils.dateToCurrentTimeZone(this.monthDate)),
        };

      this.$store.dispatch("generic/setLoading", true);
      let fileNameWithExtension = Utils.formatDateMonth(this.monthDate) + " Pricing.xlsx";
      Service.exportPricedQuantitiesBalance(body, ({success, data, message}) => {
          this.$store.dispatch("generic/setLoading", false);
  
          if(success){
              var fileURL = window.URL.createObjectURL(new Blob([data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', fileNameWithExtension);
              document.body.appendChild(fileLink);
          
              fileLink.click();
          } else{
              this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
      })
    }
  }
}

</script>

<template>
    <main>
        <div class="m-5">
            <div class="grid">
                <div class="col-2">
                    <label for="monthStartDate">{{$t('PricedQuantitiesBalance.monthStartDate')}}</label>
                    <Calendar
                    :class="{'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    view="month" dateFormat="mm/yy"
                    :showTime="false"
                    v-model="monthDate"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                </div>

                <div class="col-12 lg:col-4 m-3">
                    <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="m-2 p-button-sm" @click="getGrid()"/>
                    <ResponsiveButton :label="$t('btn.calculate')" icon="pi pi-percentage" class="m-2 p-button-success p-button-sm" @click="calculate()" 
                    v-if="!uiPermissions('PricedQuantitiesBalanceCalculateButton').isHidden" />
                    <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file-excel" class="m-2 p-button-sm" @click="exportExcel()"/>
                </div>

                <div class="col-12">
                    <DataTable scrollable scrollHeight="800px" :value="data" v-if="data.length > 0" showGridlines :rowClass="rowClass" :loading="loading">
                        <ColumnGroup type="header">
                            <Row>
                                <Column :header="$t('PricedQuantitiesBalance.description')" :rowspan="3" style="min-width: 100px;"/>
                                <Column v-for="(column, key) in headerColumns" :key="key" :header="$t('PricedQuantitiesBalance.' + key)" :colspan="calculateColspan(column)" style="min-width: 100px;" />                        
                            </Row>
                            <Row>
                                <Column v-for="(column, index) in columnConfigurations" :key="index" :header="column.name" :colspan="calculateColspanFamily(column)" style="min-width: 100px;" />
                            </Row>
                            <Row>
                                <Column v-for="(column, index) in columns" :key="index" :header="$t('PricedQuantitiesBalance.' + column.label)" style="min-width: 100px;" />
                            </Row>
                        </ColumnGroup>

                        <Column field="description" :header="$t('PricedQuantitiesBalance.description')" style="min-width: 100px;">
                            <template #body="{ data }">
                                {{ data.description }}
                            </template>
                        </Column>

                        <Column v-for="(column,index) in columns" :key="index" :header="$t('PricedQuantitiesBalance.' + column.label)" style="min-width: 100px;">
                            <template #body="{ data }">
                                {{ utils.formatDecimal(data.data[column.familyName][column.data], column.decimalPrecision) }}
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </div>

    </main>
</template>

<style>
    .bold-item{
        font-weight: bold;        
    }

    .background-item{
        background-color: rgba(255, 235, 205, 0.801) !important;
    }
        
</style>